export default {
  menu: 'Deficit',
  title: 'Deficit',

  general: {
    table: {
      header: {
        row: 'Row',
        date: 'Date',
        description: 'Description',
        type: 'Type',
        status: 'Status',
        creator: 'Creator',
        barcode: 'Barcode',
        product: 'Product',
        warehouse: 'Warehouse',
        count: 'Qty',
        delete: 'Delete',
        restore: 'Restore'
      }
    },

    labels: {
      allProduct: 'All products',
      warehouse: 'Warehouse',
      id: 'ID',
      registryDate: 'Registry date',
      type: 'Type',
      status: 'Status'
    },

    notifications: {
      isExists: {
        message: 'This value is in the list',
        dynamicMessage: 'There are {name} in the list'
      },

      increaseCount: {
        message: 'Number of items added',
        dynamicMessage: 'Number of { names } added'
      },

      productNotFount: 'No product found with this barcode',
      quantity: 'Inventory is not enough!',
      dynamicQuantity: 'There is not enough stock of {name}!',

      insert: {
        deficit: {
          success: 'Warehouse deficit registered successfully',
          error: 'Warehouse deficit registration was incorrect!'
        },
        surplus: {
          success: 'Warehouse surplus registered successfully',
          error: 'Warehouse surplus registration was incorrect!'
        }
      },

      edit: {
        deficit: {
          success: 'Warehouse deficit edited successfully',
          error: 'Warehouse deficit editing encountered an error!'
        },
        surplus: {
          success: 'Warehouse surplus edited successfully',
          error: 'Warehouse surplus editing encountered an error!'
        }
      },

      delete: {
        deficit: {
          success: 'Warehouse deficit successfully deleted',
          error: 'Deleting the warehouse deficit was accompanied by an error'
        },
        surplus: {
          success: 'Warehouse surplus successfully deleted',
          error: 'Deleting the warehouse surplus was accompanied by an error'
        }
      },

      restore: {
        deficit: {
          success: 'Warehouse deficit successfully restored',
          error: 'Restore warehouse deficit was accompanied by an error'
        },
        surplus: {
          success: 'Warehouse surplus successfully restored',
          error: 'Restore warehouse surplus was accompanied by an error'
        }
      },

      parseError: {
        storeroom: 'Warehouse not selected!',
        stocks: 'No items selected!',
        description: 'Description field is empty!',
        invoiceNumber: 'This invoice number is already selected!',
        quantity: 'The number of selected products is not valid!',
        noProductEnter: 'No Product Selected!'
      }
    },

    confirmations: {
      delete: {
        deficit: {
          title: 'Confirmation of deletion of warehouse deficit',
          body: 'If the warehouse deficit is deleted, all the documents and delivery note of the warehouse related to the invoice will be deleted. Are you sure? '
        },
        surplus: {
          title: 'Confirmation of deletion of warehouse surplus',
          body: 'If the warehouse surplus is deleted, all the documents and delivery note of the warehouse related to the invoice will be deleted. Are you sure? '
        }
      },
      forceDelete: {
        title: 'Confirmation of deletion of invoice',
        body: 'If the invoice is deleted, the information of invoice deleted and cant restore it. Are you sure? '
      },
      forceUpdate: {
        deficit: {
          title: 'Warehouse deficit edit confirmation',
          body: 'By edit warehouse deficit, All documents related to this invoice change. Are you sure of confirming edit warehouse deficit?'
        },
        surplus: {
          title: 'Warehouse surplus edit confirmation',
          body: 'By edit warehouse surplus, All documents related to this invoice change. Are you sure of confirming edit warehouse surplus?'
        }
      }
    },

    types: {
      deficit: 'Deficit',
      surplus: 'Surplus'
    },

    statusTypes: {
      draft: 'Draft',
      confirmed: 'Approved',
      deleted: 'Deleted'
    }
  },

  list: {
    title: 'Deficit'
  },

  trash: {
    title: 'Removed Warehouse Deficit List'
  },

  insert: {
    title: 'Insert Warehouse Deficit',
    dynamicTitle: {
      deficit: 'Insert Warehouse Deficit',
      surplus: 'Insert Warehouse Surplus'
    }
  },

  profile: {
    title: 'Warehouse Deficit Profile',
    dynamicTitle: {
      deficit: 'Warehouse Deficit Profile',
      surplus: 'Warehouse Surplus Profile'
    }
  },

  edit: {
    title: 'Edit Warehouse Deficit',
    dynamicTitle: {
      deficit: 'Edit Warehouse Deficit',
      surplus: 'Edit Warehouse Surplus'
    }
  },

  logs: {
    title: 'Invoice Logs'
  }
}
